import React from "react";
import { Button } from "@mui/material";

const TagButton = ({ tag, selected, handleTagClick }) => {
  return (
    <Button
      variant="outlined"
      size="small"
      style={
        tag === selected
          ? {
              textTransform: "none",
              margin: "30px 10px",
              color: "white",
              backgroundColor: "grey",
            }
          : { textTransform: "none", margin: "30px 10px" }
      }
      onClick={() => {
        handleTagClick(tag)
      }}
    >
      {tag}
    </Button>
  );
};

export default TagButton;
